export default __webpack_public_path__ + "static/media/hht2_ep08_book_wp_01.801c63b0.jpg";